import { PropsWithChildren } from 'react';

export const Headline: React.FC<PropsWithChildren<{}>> = ({ children }) => (
  <h3 className='text-left mb-4 text-xl font-bold tracking-tight leading-none text-gray-900 md:text-2xl lg:text-3xl dark:text-white'>
    {children}
  </h3>
)
